export const basePath = window.location.origin;
export const contextPath = document.querySelector('body').getAttribute('data-context-path');
export const currentLang = document.querySelector('html').getAttribute('lang');